// tslint:disable

import * as React from 'react';
import { PatternsLib } from '../../libs/patterns.lib';
import { Authorize } from '../libs/authorize';


export class ForgotPasswordComponenet extends React.Component<any, any> {
    public state: any = {
        email: '',
        password: '',
        password_again: '',
        isInvalid: false,
        isAuthenticated: false,
        errorMessage: '',
        successMessage: false,
        token: null,
    };

    public validator(item: string, value: string): boolean {
        const rules = {
            email: PatternsLib.EMAIL,
            password: PatternsLib.PASSWORD,
            password_again: PatternsLib.PASSWORD,
        };
        return rules[item].test(value);
    }

    public handleChange(property: string, event: any) {
        this.setState({
            [property]: event.target.value,
            isInvalid: false,
            isAuthenticated: false,
            errorMessage: ''
        });
    }

    public async handleSubmitReset(event: any) {
        event.preventDefault();
        const {password, password_again} = this.state;

        try {
            if (!this.validator('password', password)) {
                throw new Error('no.password');
            }
            if (!this.validator('password_again', password_again)) {
                throw new Error('no.password_again');
            }

            if (password != password_again) {
                throw new Error('Passwords do not match');
            }

            await Authorize.setNewPassword(password, this.state.token);
            window.location.href = '/login';

        } catch (err) {
            this.setState({
                isInvalid: true,
                errorMessage: err.message
            });
        }
    }
    public async handleSubmit(event: any) {
        event.preventDefault();
        const {email} = this.state;

        try {
            if (!this.validator('email', email)) {
                throw new Error('no.email');
            }
//const response: any =
            await Authorize.forgotPassword(email);

            //console.log(response)

            this.setState({successMessage: true});
            //window.location.href = '/';

        } catch (err) {
            this.setState({
                isInvalid: true,
                errorMessage: err.message
            });
        }
    }

    componentDidMount() {
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const token = params.get('token');
        this.setState({token: token})
    }

    render() {
        const {isInvalid, isAuthenticated} = this.state;
        let error = <div/>;
        if (isInvalid || isAuthenticated) {
            error = <div className="form-group">
                <div className="alert alert-danger text-center">
                    <i className="fa fa-exclamation-triangle" aria-hidden="true"/>
                    {'  ' + this.state.errorMessage}
                </div>
            </div>;
        }
        return (
            <div>
                <img src="/images/blurred-bg-2.jpg" className="login-img wow fadeIn"/>
                <div className="center-vertical">
                    <div className="center-content row">
                        <div className="col-md-6 col-lg-4 center-margin">
                            <div className="content-box wow bounceInDown modal-content">
                                <h3 className="content-box-header content-box-header-alt bg-default">
                                    <span className="icon-separator">
                                        <i className="glyph-icon icon-cog"/>
                                    </span>
                                    <span className="header-wrapper">
                                        Members area
                                        <small>Reset your password.</small>
                                    </span>
                                </h3>
                                {this.state.token === null &&
                                <form onSubmit={(event: any) => this.handleSubmit(event)}>
                                <div className="content-box-wrapper">
                                    {!this.state.successMessage &&
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor=""></label>
                                                <div className="input-group">
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        name="email"
                                                        required={true}
                                                        onChange={(event: any) => this.handleChange('email', event)}
                                                    />
                                                    <span className="input-group-addon bg-blue">
                                                        <i className="glyph-icon icon-envelope-o"/>
                                                    </span>
                                                </div>
                                            </div>
                                            {error}
                                            <button className="btn btn-primary btn-block" type="submit" name="getToken">Send mail</button>
                                        </div>
                                    }
                                    {this.state.successMessage &&
                                        <div className="alert alert-success">
                                            We have sent you an email with instructions for resetting your password.
                                        </div>
                                    }
                                </div>
                                </form>
                                }
                                {this.state.token !== null &&
                                <form onSubmit={(event: any) => this.handleSubmitReset(event)}>
                                    <div className="content-box-wrapper">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    placeholder="Password"
                                                    required={true}
                                                    name="password"
                                                    onChange={(event: any) => this.handleChange('password', event)}
                                                />
                                                <span className="input-group-addon bg-blue">
                                                    <i className="glyph-icon icon-unlock-alt"/>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    placeholder="Password again"
                                                    required={true}
                                                    name="password_again"
                                                    onChange={(event: any) => this.handleChange('password_again', event)}
                                                />
                                                <span className="input-group-addon bg-blue">
                                                    <i className="glyph-icon icon-unlock-alt"/>
                                                </span>
                                            </div>
                                        </div>
                                        {error}
                                        <button className="btn btn-primary btn-block" type="submit" name="setPw">Set new password</button>
                                    </div>
                                </form>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/forgot-password.componenet.tsx